export class ScrollUtil {

    public static saveScroll = (scrollPos: number) => {
        sessionStorage.setItem('scrollPosition', scrollPos.toString());
    };

    public static getSavedScroll = (): number => {
        return Number(sessionStorage.getItem("scrollPosition"));
    };

}